import { render, staticRenderFns } from "./ManufactureProductCategoryModal.vue?vue&type=template&id=254e1a2e&"
import script from "./ManufactureProductCategoryModal.vue?vue&type=script&lang=js&"
export * from "./ManufactureProductCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports